<div *ngIf="config; else noPlotsData" [id]="chartIdWithoutHash"></div>
<ng-template #noPlotsData>
  <h1>There is not plots data</h1>
</ng-template>
